import { Dispatch, useEffect } from 'react'
import loadViews from '../../utils/lazyLoader'
import { Icomponent } from '../../interfaces'
import { IComponentPromises } from '../../interfaces/templates'

type DispatchType = Dispatch<React.SetStateAction<IComponentPromises>>

export const useLoadViews = ({
  headerComponents,
  setHeaderComponentsList,
  bodyComponents,
  setBodyComponentsList,
  footerComponents,
  excludedUiComponents = [],
  setFooterComponentsList,
  containerUid,
}: {
  headerComponents: Icomponent[]
  setHeaderComponentsList: DispatchType
  bodyComponents: Icomponent[]
  setBodyComponentsList: DispatchType
  footerComponents: Icomponent[]
  excludedUiComponents?: string[]
  setFooterComponentsList: DispatchType
  containerUid: string
}) => {
  useEffect(() => {
    if (headerComponents && headerComponents.length > 0) {
      loadViews(headerComponents, setHeaderComponentsList)
    }

    if (bodyComponents && bodyComponents.length > 0) {
      loadViews(bodyComponents, setBodyComponentsList)
    }

    if (footerComponents && footerComponents.length > 0) {
      loadViews(
        footerComponents.filter((c) => !excludedUiComponents.includes(c.uid)),
        setFooterComponentsList,
      )
    }

    return () => {
      setHeaderComponentsList([])
      setBodyComponentsList([])
      setFooterComponentsList([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerUid])
}
